module.exports = __webpack_public_path__ + "static/img/cusQrcode.28951273.png";